module.exports = "# Overview\n\n## Content\n\n### There are four parts!\n1. Know the Risks\n2. Make a Plan\n3. Get a Kit\n4. We're In This Together\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/sections/04_overview/overview.md
// module id = 1522
// module chunks = 2